import { ActionContext } from 'vuex'
import apiAdminUmbClasse from '@/api/admin/umbClasse'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IUmbClasseState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class UmbClasseAction {
   
  public [types.UMBCLASSE_REQUEST](context: ActionContext<IUmbClasseState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.UMBCLASSE_REQUEST)
        apiAdminUmbClasse
          .getUmbClasses()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const umbClasseArray = resp.data.data as AloBaseArray<AloDbUmbClasse>
              context.commit(types.UMBCLASSE_SUCCESS, umbClasseArray.items)
              resolve(umbClasseArray.items)
            } else {
              context.commit(types.UMBCLASSE_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.UMBCLASSE_ERROR)
            reject()
          })
      })
  }

  public [types.UMBCLASSE_ENSURE_LIST](context: ActionContext<IUmbClasseState, IRootState>) {
    if(context.state.umbClasses.length == 0) {
        return context.dispatch(types.UMBCLASSE_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.umbClasses)            
        })
    }    
  }

  public [types.UMBCLASSE_SELECT_DETAIL](context: ActionContext<IUmbClasseState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const umbClasse = context.getters.umbClassesById[itemId] as AloDbUmbClasse      
      if(umbClasse) {        
        if(umbClasse.detailLoaded) {
          context.commit(types.UMBCLASSE_SELECT_DETAIL,umbClasse)
          resolve(umbClasse)
        }
        else{
          context.dispatch(types.UMBCLASSE_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.UMBCLASSE_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newUmbClasse = new AloDbUmbClasse()
        context.commit(types.UMBCLASSE_SELECT_DETAIL,new AloDbUmbClasse())
        resolve(newUmbClasse)
      }
    })
  }

  public [types.UMBCLASSE_SELECT_DETAIL_REQUEST](context: ActionContext<IUmbClasseState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.UMBCLASSE_SELECT_DETAIL_REQUEST, itemId)
        apiAdminUmbClasse
          .getUmbClasse(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const umbClasse = resp.data.data as AloDbUmbClasse
              context.commit(types.UMBCLASSE_SELECT_DETAIL_SUCCESS, umbClasse)
              context.commit(types.UMBCLASSE_SELECT_DETAIL,umbClasse)
              resolve(umbClasse)
            } else {
              context.commit(types.UMBCLASSE_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.UMBCLASSE_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.UMBCLASSE_SAVE_REQUEST](context: ActionContext<IUmbClasseState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmUmbClasse.id
        context.commit(types.UMBCLASSE_SAVE_REQUEST,context.state.modifiedAdmUmbClasse.UMC_LIBELLE)
        apiAdminUmbClasse
          .saveUmbClasse(context.state.modifiedAdmUmbClasse)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const umbClasse = resp.data.data as AloDbUmbClasse            
              context.commit(types.UMBCLASSE_SELECT_DETAIL_SUCCESS, umbClasse)
              context.commit(types.UMBCLASSE_SELECT_DETAIL,umbClasse)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:umbClasse.UMC_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewUmbClasse') router.push({name:'EditUmbClasse',params:{umbClasseid:umbClasse.id!.toString()}})
              resolve(umbClasse)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.UMBCLASSE_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.UMBCLASSE_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.UMBCLASSE_UPDATE_MODIFIED_ADM](context: ActionContext<IUmbClasseState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBCLASSE_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmUmbClasse)
    })
  }
  
  public [types.UMBCLASSE_CANCEL_MODIFIED_ADM](context: ActionContext<IUmbClasseState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBCLASSE_SELECT_DETAIL,context.state.originalAdmUmbClasse)
      resolve(context.state.modifiedAdmUmbClasse)
    })
  }

  public [types.UMBCLASSE_UPDATE_FILTER_ADM](context: ActionContext<IUmbClasseState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UMBCLASSE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  
}

export default util.classToObject(UmbClasseAction)